<template>
  <div
    v-if="internalValue && internalProfileValue"
    id="applicant-internal-data-form"
  >
    <div class="vx-row">
      <div class="vx-col w-full mt-4 md:mt-0">
        <div class="vx-row">
          <div class="vx-col w-full">
            <h3>Ordnungsmerkmale</h3>
          </div>
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col w-full md:w-1/3">
                <DataInput
                  v-model="internalValue.privacyPolicyAccepted"
                  type="bool"
                  class="w-full mt-4"
                  label="Datenschutzerklärung akzeptiert"
                  name="privacyPolicyAccepted"
                />
              </div>
              <div
                v-if="
                  internalValue.id &&
                    !internalValue.privacyPolicyAccepted &&
                    !privacyPolicyRequested
                "
                class="vx-col w-full md:w-1/3"
              >
                <vs-button class="w-full mt-4" @click="requestPrivacyPolicy"
                  >Datenschutzerklärung anfordern</vs-button
                >
              </div>
              <div
                v-if="internalValue.privacyPolicyRequestedDate"
                class="vx-col w-full md:w-1/3"
              >
                Datenschutzerklärung am
                {{
                  $d(new Date(internalValue.privacyPolicyRequestedDate), "long")
                }}
                angefragt.
              </div>
            </div>
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalProfileValue.internalConsultantID"
              :initial-value="internalProfileValue.internalConsultant"
              type="model"
              class="w-full mt-4"
              label="Berater"
              name="consultant"
              model-label="
                firstName
                lastName"
              :select-label="el => el.firstName + ' ' + el.lastName"
              gql-query="consultantsPage"
              gql-single-query="consultant"
              gql-filter-type="objectFilter"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalProfileValue.stateID"
              :initial-value="internalProfileValue.state"
              type="model"
              class="w-full mt-4"
              label="Status"
              name="state"
              gql-query="applicantStates"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalValue.userGroupID"
              :initial-value="internalValue.group"
              type="model"
              class="w-full mt-4"
              required
              validation-rules="required"
              label="Benutzergruppe"
              name="group"
              gql-query="userGroups"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalProfileValue.skillJobTypeID"
              :initial-value="internalProfileValue.skillJobType"
              type="model"
              class="w-full mt-4"
              label="Berufsbereich"
              name="internalProfileValue.skillJobType"
              gql-query="applicantSkillJobTypes"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalValue.source"
              type="model"
              required
              validation-rules="required"
              class="w-full mt-4"
              label="Herkunft Bewerber"
              name="source"
              gql-query="applicantSources"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              v-model="internalValue.entryTypeID"
              :initial-value="internalValue.entryType"
              type="model"
              class="w-full mt-4"
              label="Eingangsart"
              name="entryType"
              gql-query="applicantEntryTypes"
            />
          </div>
        </div>
      </div>
      <div class="vx-col w-full mt-4">
        <div class="vx-row">
          <div class="vx-col w-full">
            <h3>Bewertung</h3>
          </div>
          <div class="vx-col w-full">
            <DataInput
              v-model="internalProfileValue.rating"
              class="w-full mt-4"
              label="Bewertung (generell)"
              name="internalProfileValue.rating"
              type="select"
              :options="[
                { code: 1, label: '1' },
                { code: 2, label: '2' },
                { code: 3, label: '3' },
                { code: 4, label: '4' },
                { code: 5, label: '5' }
              ]"
            />
          </div>
          <div class="vx-col w-full">
            <DataInput
              v-model="internalProfileValue.internalRatingComment"
              type="html"
              class="w-full mt-4"
              label="Anmerkungen (wird nicht publiziert)"
              name="internalRatingComment"
            />
          </div>
        </div>
      </div>
      <div class="vx-col w-full mt-4 md:mt-8 md:w-1/2">
        <div class="vx-row">
          <div class="vx-col w-full">
            <h3>Login / Registrierung</h3>
          </div>
          <div class="vx-col w-full md:w-4/12">
            <DataInput
              v-model="internalValue.wantsNewsletter"
              type="bool"
              class="w-full mt-4"
              label="Newsletter"
              name="wantsNewsletter"
            />
          </div>
          <div class="vx-col w-full md:w-4/12">
            <DataInput
              v-model="internalProfileValue.active"
              type="bool"
              class="w-full mt-4"
              label="Profil aktiv"
              name="internalProfileValue.active"
            />
          </div>
          <div class="vx-col w-full md:w-4/12">
            <DataInput
              v-model="internalValue.l1sync"
              type="bool"
              class="w-full mt-4"
              label="Zu L1 Synchonisieren"
              name="internalValue.l1sync"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import gql from "graphql-tag";

export default {
  components: {
    DataInput
  },
  props: {
    value: { type: Object, required: true },
    profile: { type: Object, required: true }
  },
  data: () => ({
    privacyPolicyRequested: false
  }),
  apollo: {
    me: gql`
      query {
        me {
          id
          email
          consultant {
            id
            firstName
            lastName
            telephone
            fax
            zip
            city
            street
          }
        }
      }
    `
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    internalProfileValue: {
      get() {
        return this.profile;
      },
      set(val) {
        this.$emit("profileInput", val);
      }
    }
  },
  watch: {
    internalValue: {
      deep: true,
      handler: function(v) {
        this.internalValue = v;
      }
    },
    internalProfileValue: {
      deep: true,
      handler: function(v) {
        this.internalProfileValue = v;
      }
    }
  },
  methods: {
    requestPrivacyPolicy() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!, $senderInfo: ConsultantSignature!) {
              requestApplicantPrivacyPolicy(
                applicantID: $id
                senderInfo: $senderInfo
              )
            }
          `,
          variables: {
            id: this.internalValue.id,
            senderInfo: {
              firstName: this.me.consultant.firstName,
              lastName: this.me.consultant.lastName,
              street: this.me.consultant.street,
              zip: this.me.consultant.zip,
              city: this.me.consultant.city,
              phone: this.me.consultant.telephone,
              fax: this.me.consultant.fax,
              email: this.me.email
            }
          }
        })
        .then(() => {
          this.$vs.notify({
            title: "Datenschutz",
            text:
              "E-Mail zum bestätigen der Datenschutzerklärung wurde erfolgreich versendet.",
            color: "success",
            icon: "mail_outline",
            time: 4000,
            position: "bottom-center"
          });
          this.privacyPolicyRequested = true;
        });
    }
  }
};
</script>
